import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import Chatbot from '../../components/Chatbot';
import StickyMobileCTA from '../../components/mobile/StickyMobileCTA';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import CapabilitiesSection from './CapabilitiesSection';
import HowItWorksSection from './HowItWorksSection';
import DiagnosticPreviewSection from './DiagnosticPreviewSection';
import TestimonialsSection from './TestimonialsSection';
import PatentSection from './PatentSection';
import ForStudentsSection from './ForStudentsSection';
import ForParentsSection from './ForParentsSection';
import PricingSection from './PricingSection';
import AboutSection from './AboutSection';
import ScrollShowcaseSection from './ScrollShowcaseSection';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <ScrollShowcaseSection />
        <CapabilitiesSection />
        <HowItWorksSection />
        <DiagnosticPreviewSection />
        <TestimonialsSection />
        <PatentSection />
        <ForStudentsSection />
        <ForParentsSection />
        <PricingSection />
        <AboutSection />
      </main>
      <Footer />
      <Chatbot />
      {/* Sticky Mobile CTA */}
      <StickyMobileCTA />
    </div>
  );
}
